exports = module.exports = require("../../../NodeModules/Ljbc/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.RadioButtonList span[data-v-79d11e69] {\n}\n", ""]);

// exports
